import TagManager from 'react-gtm-module';

import { valueType } from './IGTMContent';

/** abstract class for handle TagManager and contents like DataLayer or etc */
export abstract class DataLayerHandler {
  /** Record<string, valueType> = {
   *   key0: "value0",
   *   key1: [
   *    {
   *        key1_1:"value1-1",
   *        key1_2:[
   *            "value1-2-1",
   *            "value1-2-2"
   *        ]
   *    }
   *   ]
   * }
   *
   *
   * type valueType = object | object[] | string | string[] */
  public static addDataLayer(content: Record<string, valueType>): void {
    const pairs = Object.entries(content).map(([key, value]) => ({ key, value }));
    const dataLayer: object = Object.fromEntries(pairs?.map((o) => [o.key, o.value]));

    if (Object.keys(dataLayer).length > 0)
      TagManager.dataLayer({
        dataLayer,
      });
  }

  public static addDataLayerPush(content: Record<string, any>): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(content);
  }

  /**abstract method to add event to GTM
   *
   *
   * type valueType = object | object[] | string | string[]
   *
   *
   * Note: Please use their own method for special events like "addPageView", "addGoToWepod" etc. */
  public static addEvent(
    eventname: string,
    eventValue?: valueType | undefined,
    eventMetaDate?: Record<string, valueType> | undefined
  ) {
    this.addDataLayer({
      event: eventname,
      gtm: {
        [eventname]: eventValue ?? eventname,
        ...eventMetaDate,
      },
      eventValue: eventValue ?? eventname,
    });
  }

  public static addEventPush(
    eventname: string,
    eventValue?: valueType | undefined,
    eventMetaDate?: Record<string, valueType> | undefined
  ) {
    this.addDataLayerPush({
      event: eventname,
      gtm: {
        [eventname]: eventValue ?? eventname,
        ...eventMetaDate,
      },
      id: eventValue ?? eventname,
    });
  }

  public static addPageView(pageTitle: string, pageDescription?: string | undefined): void {
    this.addEvent('page_view', `${pageTitle}${pageDescription ? '-' + pageDescription : ''}`);
  }
  public static addError(description?: string, code?: string): void {
    this.addEventPush('error', `${code} '-' ${description}`);
  }

  public static addGoToWepod(value?: string | undefined): void {
    this.addEvent('go_to_wepod', value);
  }

  public static addCountDownVisibility(value?: string | undefined): void {
    this.addEvent('count_down_visibility', value);
  }
}
